export interface IMeasurements {
  extraSmall: string;
  extraLarge: string;
  large: string;
  medium: string;
  shadows: {
    'elevation-1': string;
    'elevation-2': string;
    'elevation-3': string;
    'elevation-4': string;
    'elevation-5': string;
    'elevation-6': string;
  };
  small: string;
}
export const measurements = {
  zero: '0',
  extraExtraExtraSmall: '2px',
  extraExtraSmall: '4px',
  extraSmall: '8px',
  extraLarge: '56px',
  extraExtraLarge: '80px',
  large: '32px',
  medium: '24px',
  small: '16px',
  shadows: {
    'elevation-1': '0px 1px 1px 0px',
    'elevation-2': '0px 1px 3px 0px',
    'elevation-3': '0px 2px 4px 0px',
    'elevation-4': '0px 4px 8px 0px',
    'elevation-5': '0px 8px 16px 0px',
    'elevation-6': '0px 16px 24px 0px'
  }
};